'use client'

import styled from 'styled-components'
import { HTMLAttributes } from 'react'

interface SpacerBaseProps extends HTMLAttributes<HTMLDivElement> {
  xs?: number | string;
  sm?: number | string;
  md?: number | string;
  lg?: number | string;
  xl?: number | string;
  xxl?: number | string;
}

const SpacerBase = styled.div<SpacerBaseProps>`
  ${({ theme, ...p }) => Object.entries(theme.breakpoints).map(([dim]) => {
    const key = `${dim}` as keyof SpacerBaseProps;
    return p[key] && theme.mediaQuery[dim](`
      height: ${!p[key] || Number(p[key]) == 0 ? 0 : theme.spacing(p[key])};
    `);
  })}
`

export default SpacerBase
